import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions'
import { bindActionCreators } from 'redux';
import AdminDashboard from './components/AdminDashboard';
import CompanyDashboard from './components/CompanyDashboard';
import NewUserDashboard from './components/NewUserDashboard';
import StudentDashboardNew from './components/StudentDashboardNew';
import InstructorDashboardNew from './components/InstructorDashboardNew';

const styles = theme => ({
});

class Dashboard extends Component {

    constructor(props) {
        super(props);
        // if (props.auth.user.role != 'guest') {
        //     if (props.auth.user.data.role_info.role_id === 5) {
        //         this.props.history.push('/company/edit/' + props.auth.user.data.role_info.company_id)
        //     }
        // }
    }

    render() {
        const { auth } = this.props;
        switch (auth.user.role) {
            case ("instructor"):
                {
                    // return <InstructorDashboard />
                    return <InstructorDashboardNew />
                }

            case ("student"):
                {
                    if (auth.user.NewUser) {
                        return <NewUserDashboard />
                    }
                    // return <StudentDashboard />
                    return <StudentDashboardNew />
                }

            case ('dev'):
            case ("admin"):
                {
                    return <AdminDashboard />
                }
            case ('company'):
                {
                    return <CompanyDashboard />
                }
            case ('NewUser'):
                {
                    return <React.Fragment>This will be the new user dash</React.Fragment>
                }
            default:
                {
                    return <React.Fragment>Error: No Dashboard Available</React.Fragment>
                }
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getLayout: Actions.getLayout
    }, dispatch);
}

function mapStateToProps({ auth, fuse, dashboardApp }) {
    return {
        dashboard_layout: dashboardApp.dashboard.dashboard_layout,
        settings: fuse.settings.current,
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard)));


// WEBPACK FOOTER //
// src/main/content/dashboard/Dashboard.js